<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM8.60107 11.8273C8.26614 11.4654 7.68764 11.4315 7.30895 11.7516C6.93026 12.0717 6.89479 12.6245 7.22972 12.9863L10.167 16.16L16.9418 9.4837C17.2937 9.13687 17.2848 8.58308 16.9219 8.24677C16.5589 7.91045 15.9794 7.91897 15.6275 8.2658L10.2288 13.586L8.60107 11.8273Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'TickCircleIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
